<template>
  <div class="content has-text-centered">
    <live
      :translations="translations"
      :step="step"
      :legalType="legalType"
      :upgrade="upgrade"
      v-if="$route.meta.registerComponent == 'Live' || $route.meta.registerComponent == 'Upgrade-live'"
    ></live>
    <demo
      :translations="translations"
      :step="step"
      :legalType="legalType"
      v-if="$route.meta.registerComponent == 'Demo'"
    ></demo>
    <partner
      :translations="translations"
      :step="step"
      :legalType="legalType"
      v-if="$route.meta.registerComponent == 'Partner'"
    ></partner>
  </div>
</template>

<script>
import Live from './Live.vue'
import Demo from './Demo.vue'
import Partner from './Partner.vue'
import { service } from '../../app'
import { mapGetters, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import config from '../../config'
import { Base64 } from 'js-base64'

export default {
  components: {
    Live,
    Demo,
    Partner,
  },
  data() {
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
      logID: 0,
      step: 0,
      skipStep: null,
      type: this.$route.meta.registerComponent.toLowerCase(),
      upgrade: false,
      userID: false,
      legalType: 'individual',
      isLead: false,
      formData: {},
      translations: {
        months: {},
        genders: {},
        text: {},
      },
      loadingNextStep: false,
    }
  },
  watch: {
    Language(l) {
      if (l !== null && typeof l !== 'undefined') {
        Validator.localize(l)
        this.setTranslations()
      }
    },
    'BonusConfig.noDepositBonus.enabled'() {
      if (this.BonusConfig.noDepositBonus.enabled) {
        if (this.$route.query.ndbonus === '1') {
          this.$bus.$emit('grantNoDepositBonus', true)
        }
      }
    },
  },
  computed: {
    TOSURL() {
      return config.URL.website + 'company/legal-documents/'
      // return config.URL.website + 'pdf/' + this.Language + '/legal-risk-disclosure.pdf'
    },
    bonusTOSURL() {
      return 'https://eurotrader-com.s3.eu-west-2.amazonaws.com/pdf/111-deposit-bonus-terms.pdf'
    },
    PrivacyURL() {
      return 'https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Privacy%20Policy.pdf'
      // return config.URL.website + 'pdf/' + this.Language + '/legal-risk-disclosure.pdf'
    },
    termsAndConditionsURL() {
      return 'https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Terms%20and%20Conditions.pdf'
      // return config.URL.website + 'pdf/' + this.Language + '/legal-risk-disclosure.pdf'
    },
    riskDisclosureURL() {
      return 'https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf'
      // return config.URL.website + 'pdf/' + this.Language + '/legal-risk-disclosure.pdf'
    },
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      BonusConfig: 'bonusconfig/all',
    }),
  },
  mounted() {
    // legacy redirection links
    if (this.$route.query.refid !== undefined) {
      // get first ib code
      const IBID = parseInt(this.$route.query.refid)
      service
        .get('/ib/legacy/get-first-code', {
          params: {
            ibid: IBID,
          },
        })
        .then(response => {
          // redirect a couple times :)
          window.location = `/${this.Language}/ib/r?t=${response.data.tracking_link}`
        })

      return
    }

    if (this.type === 'upgrade-live') {
      if (this.$store.state.user.info.ID <= 0) {
        // needs to be logged in
        this.$toasted.error(this.$t('invalid_request_login_required') + '<span class="error-id"></span>', { duration: 4000 })
        this.$router.push('/' + this.Language + '/login')
        return
      }
      if ('live'.indexOf(this.User.accountTypes) !== -1) {
        // already a live account
        this.$toasted.error(this.$t('error_live_account_already') + '<span class="error-id"></span>', { duration: 4000 })
        this.$router.push('/' + this.Language + '/')
        return
      }
      this.upgrade = true
      this.type = 'live'
      this.userID = this.$store.state.user.info.ID
    }
    if (this.type === 'live' || this.type === 'demo') {
      // remove get parameters
      history.replaceState({}, this.$route.name, this.$route.path)
      this.handleQuery()
    }
    this.setTranslations()
    Validator.localize(this.Language)
    this.$bus.$on('Complete', this.onComplete)
    this.$bus.$on('NextStep', this.onNextStep)
    this.$bus.$on('PreviousStep', this.onPreviousStep)
    this.$bus.$on('SelectLegalType', this.onSelectLegalType)
  },
  created() {
    if (this.type === 'upgrade-live' && this.$store.state.user.info.ID > 0 && 'live'.indexOf(this.User.accountTypes) === -1) {
      this.upgrade = true
      this.type = 'live'
      this.userID = this.$store.state.user.info.ID
      this.onSelectLegalType(this.legalType)
    }
  },
  beforeDestroy() {
    this.$bus.$off('Complete', this.onComplete)
    this.$bus.$off('NextStep', this.onNextStep)
    this.$bus.$off('PreviousStep', this.onPreviousStep)
    this.$bus.$off('SelectLegalType', this.onSelectLegalType)
  },
  methods: {
    handleQuery() {
      // for simple lead
      if (Object.keys(this.$route.query).length > 0) {
        if (this.type === 'live') {
          if (this.$route.query.company !== undefined) {
            this.onSelectLegalType('company')
          } else {
            // for live, set legaltype to individual
            this.onSelectLegalType('individual')
          }
        }
        let required = ['title', 'firstname', 'lastname', 'email', 'phone']
        let leadData = {}
        for (let v of required) {
          if (this.$route.query[v] === '') {
            return
          }
          leadData[v] = this.$route.query[v]
        }
        // country code uppercase
        // this.$route.query['country'] = this.$route.query['country'].toUpperCase()
        // log
        this.isLead = true
        this.$bus.$emit('isLead', this.isLead)
        let data = {
          ID: this.logID,
          type: this.type,
          step: this.step,
          legalType: this.legalType,
          formData: leadData,
          isLead: this.isLead,
        }
        // log here
        service.post('/users/create/log', data).then(response => {
          this.logID = response.data.ID
        })
      }
    },
    onComplete(formData) {
      if (!formData.tos_with_link || (formData.include_account_in_bonus_program && !formData.bonus_tos_with_link)) {
        this.$toasted.error(this.$t('must_agree_terms'))
        return
      }

      // if (this.type !== 'demo' && !formData.i_am_over_18) {
      //   this.$toasted.error(this.$t('must_be_over_18'))
      //   return
      // }

      if (this.type !== 'demo' && formData.dateofbirth && this.legalType != 'company') {
        let dobDate = formData.dateofbirth
        let dobSplitDate = dobDate.split('-')
        let dobYear = dobSplitDate[0]

        if (new Date().getFullYear() - dobYear < 18) {
          this.$toasted.error(this.$t('must_be_over_18'))
          return
        }
      }

      let data = {
        ID: this.logID,
        type: this.type,
        step: this.step,
        legalType: this.legalType,
        formData: formData,
        isLead: this.isLead,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium,
        utm_campaign: this.utm_campaign,
        utm_term: this.utm_term,
        utm_content: this.utm_content,
      }

      // upgrade url
      let url = '/users/create/'
      if (this.upgrade) {
        url = '/users/upgrade/'
        data.userID = this.userID
      }

      // register
      data.ID = this.logID
      data.IBCode = this.$getCookie('refcode') === undefined ? '' : this.$getCookie('refcode')
      data.CXToken = this.$getCookie('cx_token') === undefined ? '' : this.$getCookie('cx_token')
      data.affID = parseInt(this.$getCookie('aff_id'))
      data.device = '-'
      data.lang = this.Language

      for (let utm of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']) {
        if (this.$route.query[utm] !== undefined) {
          data[utm] = this.$route.query[utm]
        }
      }

      if (this.$getCookie('utm_source') !== undefined) {
        data.utm_source = this.$getCookie('utm_source')
      }
      if (this.$getCookie('utm_medium') !== undefined) {
        data.utm_medium = this.$getCookie('utm_medium')
      }
      if (this.$getCookie('utm_campaign') !== undefined) {
        data.utm_campaign = this.$getCookie('utm_campaign')
      }
      if (this.$getCookie('utm_term') !== undefined) {
        data.utm_term = this.$getCookie('utm_term')
      }
      if (this.$getCookie('utm_content') !== undefined) {
        data.utm_content = this.$getCookie('utm_content')
      }
      if (data.formData.startingDemoBalance && data.formData.startingDemoBalance !== '') {
        data.formData.startingDemoBalance = parseFloat(data.formData.startingDemoBalance)
      }

      // last log
      service
        .post('/users/create/log', data)
        .then(response => {
          data.userIP = response.data.UserIP
          this.logID = response.data.ID

          service
            .post(url + this.type.toLowerCase(), data)
            .then(response => {
              if (!response.data.success) {
                if (response.data.errors) {
                  let errk = Object.keys(response.data.errors)
                  for (let i = 0; i < errk.length; i++) {
                    if (this.translations.text[errk[i]]) {
                      if (response.data.errors[errk[i]] === 'required') {
                        this.$toasted.error(this.$t('error_missing_required_field') + this.translations.text[errk[i]] + '"', { duration: 10000 })
                      }
                    }
                  }
                } else {
                  this.$toasted.error(this.$t('error_contact_support'))
                }
                return
              }

              if (this.upgrade) {
                if (response.data.success) {
                  if (this.type === 'live') {
                    this.$toasted.success(this.$t('upgraded_to_a_live_account_successfully'))
                    this.$toasted.success(this.$t('password_generated_for_ta'), { duration: 7000 })
                  }
                  this['user/reset']()
                  this['user/setInfo']({ ID: this.userID })
                  this.$router.push('/' + this.Language + '/' + config.defaultURL)
                  this.$gtag.event('upgrade_to_live', {
                    event_category: 'onboarding',
                    event_label: 'Upgrade to live',
                  })
                }
              } else {
                this.login(data.formData.email, data.formData.password, data.formData.recaptchaToken)
                this.$gtag.event('sign_up_' + this.type, {
                  event_category: 'onboarding',
                  event_label: 'sign up ' + this.type,
                })
              }
            })
            .catch(error => {
              if (typeof error.response !== 'undefined') {
                if (typeof error.response.data !== 'undefined') {
                  this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>', { duration: 10000 })
                }
              }
            })
        })
        .catch(error => {
          if (typeof error.response !== 'undefined') {
            if (typeof error.response.data !== 'undefined') {
              this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>', { duration: 10000 })
            }
          }
        })
    },
    login(email, password, recaptchaToken) {
      this.$auth
        .login({
          url: config.API.host + 'authenticate/login',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + Base64.encode(email.trim() + ':' + password + ':' + recaptchaToken),
          },
          redirect: {
            name: 'Quick menu | english',
          },
          staySignedIn: true,
        })
        .then(
          () => {
            // Success
            this.$auth.fetch().then(() => {
              // Success
              this.$bus.$emit('LiveFeedConnect')
            })
          },
          err => {
            // Error
            if (err.response) {
              this.error = err.response.data
              this.$store.state.token = null
            }
          }
        )
    },
    onNextStep(formData) {
      if (this.loadingNextStep) {
        return
      }
      this.loadingNextStep = true

      let typeLog = this.type
      if (this.upgrade) {
        typeLog = 'upgrade-' + typeLog
        formData.userID = this.userID
      }
      let data = {
        ID: this.logID,
        type: typeLog,
        step: this.step,
        legalType: this.legalType,
        formData: formData,
        isLead: this.isLead,
      }
      if (this.$getCookie('refcode') !== undefined) {
        data.IBCode = this.$getCookie('refcode')
      }

      // log here
      service
        .post('/users/create/log', data)
        .then(response => {
          this.logID = response.data.ID
          // next step
          this.step++
          while (this.step === this.skipStep) {
            this.step++
          }
          window.scroll(0, 0)
          this.loadingNextStep = false
        })
        .catch(() => {
          this.loadingNextStep = false
        })
    },
    onPreviousStep() {
      this.step--
      while (this.step === this.skipStep) {
        this.step--
      }
    },
    onSelectLegalType(type) {
      this.legalType = type
      if (this.legalType === 'individual' && this.upgrade) {
        this.skipStep = 1
      }
      this.step++
      while (this.step === this.skipStep) {
        this.step++
      }
      window.scroll(0, 0)
    },
    setTranslations() {
      this.translations.months = {
        1: this.$t('january').tTitle(),
        2: this.$t('february').tTitle(),
        3: this.$t('march').tTitle(),
        4: this.$t('april').tTitle(),
        5: this.$t('may').tTitle(),
        6: this.$t('june').tTitle(),
        7: this.$t('july').tTitle(),
        8: this.$t('august').tTitle(),
        9: this.$t('september').tTitle(),
        10: this.$t('october').tTitle(),
        11: this.$t('november').tTitle(),
        12: this.$t('december').tTitle(),
      }
      this.translations.genders = {
        male: this.$t('male').tTitle(),
        female: this.$t('female').tTitle(),
      }
      this.translations.text = {
        title: this.$t('title').tTitle(),
        firstname: this.$t('first_name').tTitle(),
        lastname: this.$t('last_name').tTitle(),
        email: this.$t('email').tTitle(),
        phone: this.$t('phone').tTitle(),
        country: this.$t('country').tTitle(),
        date_of_birth: this.$t('date_of_birth').tTitle(),
        day: this.$t('day').tTitle(),
        month: this.$t('month').tTitle(),
        year: this.$t('year').tTitle(),
        nationality: this.$t('nationality').tTitle(),
        gender: this.$t('gender').tTitle(),
        address: this.$t('address_line').tTitle(),
        address2: this.$t('address_line_2').tTitle(),
        post_code: this.$t('post_code').tTitle(),
        city: this.$t('city_town').tTitle(),
        state_province: this.$t('state_province').tTitle(),
        year_moved_to_address: this.$t('year_moved_to_address').tTitle(),
        website: this.$t('website').tTitle(),
        skype_id: this.$t('skype_id').tTitle(),
        password: this.$t('password').tTitle(),
        confirm_password: this.$t('confirm_password').tTitle(),
        total_estimated_net_worth: this.$t('total_estimated_net_worth').tTitle(),
        select_option: this.$t('select_option').tTitle(),
        total_estimated_annual_income: this.$t('total_estimated_annual_income').tTitle(),
        employment_status: this.$t('employment_status').tTitle(),
        employed: this.$t('employed').tTitle(),
        self_employed: this.$t('self_employed').tTitle(),
        retired: this.$t('retired').tTitle(),
        student: this.$t('student').tTitle(),
        unemployed: this.$t('unemployed').tTitle(),
        source_of_income: this.$t('source_of_income').tTitle(),
        employment: this.$t('employment').tTitle(),
        inheritance: this.$t('inheritance').tTitle(),
        investment: this.$t('investment').tTitle(),
        other: this.$t('other').tTitle(),
        forex_cfds_and_other_instruments: this.$t('forex_cfds_and_other_instruments').tTitle(),
        yes: this.$t('yes').tTitle(),
        no: this.$t('no').tTitle(),
        lose_capital_risk: this.$t('lose_capital_risk').tTitle(),
        prev_pro_qualifications: this.$t('prev_pro_qualifications').tTitle(),
        choose_trading_platform: this.$t('choose_trading_platform').tTitle(),
        platform: this.$t('platform').tTitle(),
        account_type: this.$t('account_type').tTitle(),
        choose_currency: this.$t('choose_currency').tTitle(),
        include_account_in_bonus_program: this.$t('include_account_in_bonus_program').tTitle(),
        company_name: this.$t('company_name').tTitle(),
        date_of_registration: this.$t('date_of_registration').tTitle(),
        number_of_shareholders: this.$t('number_of_shareholders').tTitle(),
        number_of_directors: this.$t('number_of_directors').tTitle(),
        target_geo_location: this.$t('what_geographic_region').tTitle(),
        company_website: this.$t('company_website').tTitle(),
        not_required: this.$t('not_required'),
        tos_with_link: this.$t('tos_with_link', { URL: this.TOSURL }),
        bonus_tos_with_link: this.$t('bonus_tos_with_link', { URL: this.bonusTOSURL }),
        agree_terms_marketing: this.$t('agree_terms_marketing', { PRIVACY_URL: this.PrivacyURL }),
        i_am_over_18: this.$t('i_am_over_18'),
        select_starting_balance: this.$t('select_starting_balance', { URL: this.bonusTOSURL }),
        data_policy_text: this.$t('data_policy_text', { TERMS_CONDITIONS_URL: this.termsAndConditionsURL, RISK_DISCLOSURE_URL: this.riskDisclosureURL }),
      }
    },
    ...mapActions(['user/reset', 'user/setAccountTypes', 'user/set', 'user/setInfo']),
  },
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/initial-variables';
@import '~bulma/sass/utilities/mixins';
@import '../../assets/css/variables';
@import '../../assets/css/flags';
@import '../../assets/css/fa';
.step {
  > h1,
  > h2 {
    text-align: left;
    font-weight: 700;
    color: $secondary;
    border-bottom: 2px solid $primary;
    margin-bottom: 30px;
    &.center {
      border: none;
      text-align: center;
    }
  }
  label {
    text-align: left;
    font-weight: 700;
    font-size: 16px;
  }

  .btn-step0 {
    width: 260px;
    height: 260px;
    margin: 100px 20px 50px 20px;
    line-height: 260px;
    text-align: center;
    font-size: 40px;
    font-weight: 300;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #9e9e9e;
    cursor: pointer;

    @media screen and (max-width: $tablet) {
      max-width: 130px;
      max-height: 130px;
      font-size: 18px;
      margin: 0 10px 0 0;
    }

    &:hover {
      background-color: $primary;
      color: #ffffff;
      font-weight: 900;
    }
  }
}

div.shareholders-directors {
  h2 {
    padding: 5px 0;
    color: $primary;
    border-color: #bdbdbd;
  }
  width: 90%;
  margin: 0 5% 20px 5%;
  border: 1px solid #bdbdbd;
  padding: 0 0 20px;
  > .columns {
    padding: 0 20px;
  }
}

.progressNum {
  width: 100%;
  margin: 10px auto 70px;
  > ul {
    margin: 0;
    padding: 0;
    counter-reset: step;
    z-index: 1;
    &:after {
      content: '';
      display: block;
      clear: both;
    }
    li {
      list-style-type: none;
      width: 33.3%;
      float: left;
      font-size: 24px;
      position: relative;
      text-align: center;
      text-transform: uppercase;
      color: #a4a3c7;
      margin: 0;
      &:before {
        width: 40px;
        height: 40px;
        content: counter(step);
        counter-increment: step;
        line-height: 39px;
        border: 2px solid #edccdb;
        display: block;
        text-align: center;
        margin: 0 auto 10px auto;
        border-radius: 50%;
        background-color: white;
      }
      &:after {
        width: 100%;
        height: 2px;
        content: '';
        position: absolute;
        background-color: #ffbabc;
        top: 20px;
        left: -50%;
        z-index: -1;
      }
      &:first-child:after {
        content: none;
      }
      &.active {
        color: $secondary;
        font-weight: 700;
        &:before {
          border-color: $primary;
        }
        + li:after {
          height: 60px;
          background: $red;
          background: -moz-linear-gradient(left, $red 51%, #ffbabc 100%);
          background: -webkit-linear-gradient(left, $red 51%, #ffbabc 100%);
          background: linear-gradient(to right, $red 51%, #ffbabc 100%);
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$red', endColorstr='#ffbabc',GradientType=1 );
        }
      }
      &.complete:before {
        background-color: #019147;
        color: #fff;
        border-color: #019147;
      }
    }
  }
}

input.dialCode {
  width: calc(100% - 35px);
  min-width: 50px;
  float: left;
}
img.flag {
  width: 30px;
  height: 18px;
  background-size: 30px 18px;
  margin-top: 9px;
  margin-right: 5px;
  float: left;
}

.privacy_data_text {
  color: #7b7c7e;
  font: normal normal 300 12px/17px Roboto;
  a:hover {
    color: #6826f4;
  }
}

.disabledButton {
  pointer-events: none;
}

main.register section#content .content {
  max-width: 1000px;
}

.demo .column {
  width: 44%;
  @media screen and (max-width: $tablet) {
    width: 100%;
    .sub_inner {
      margin-left: 0;
    }
  }
}
.demo .step {
  width: 56%;
  @media screen and (max-width: $tablet) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Base.vue?7e741914